import React,{ useState  } from "react";
import { track, EVENTS } from '../../utils/analyticsService';

import styles from "./Login.module.css";
import MobileIcon from "../../asset/icons/MobileIcon.png"
import { NumberEntryPopUp } from "../../components";
import { LoginSignupCommon } from "../../commonComponents";
import  Api from "../../utils/Api/Api";
import { useNavigate } from "react-router-dom";

export const Login = ()=>{
    const navigate = useNavigate()

    const [showPopUps,setShowPopUps] = useState({mobileNoEntry:true});
    
    const toggelNumberEntryPopUp = ()=>{
        setShowPopUps((pre_state)=>{
            return {...pre_state,mobileNoEntry:!pre_state.mobileNoEntry}
        })
    }

    const GetOtp = async (phoneNo)=>{
        try{
            const {data} = await Api.GetOtp({phone:phoneNo});
            localStorage.setItem('phoneNo', phoneNo);

            // No body: not registered (the interceptor resolves the 400), so
            // the signup form sends the OTP instead.
            if(!data) {
                return navigate(`/signup`);
            }
            track(EVENTS.OTP_REQUESTED, { is_resend: false, context: 'login_page' });
            navigate(`/login/verify-user`)
        }
        catch(err){
            console.log('----------', err)
            track(EVENTS.OTP_REQUEST_FAILED, { reason: err?.response?.status ? `http_${err.response.status}` : 'network_error', is_resend: false, context: 'login_page' });
        }
    }
    return(
        <div className={styles.LoginPage}>
            <div className={styles.mobileLogin}>
                <div className={styles.loginHome}>
                    {/* <div className={styles.backCard}>
                        <img className={styles.cheveron} src={chevronLeft} alt="Cheveron" />
                        <div className={styles.welcomeText}>Welcome to Fleek</div>
                        <div className={styles.welcomeSubText}>Enter your phone number to continue</div>
                    </div> */}
                    {/* <LoginSignupCommon title={"Welcome to Fleek"} subtitile={"Enter your phone number to continue"} /> */}
                    {/* <div className={styles.optionContainer}> 
                        <p className={styles.getStarted}>Get started with</p>
                        <div onClick={toggelNumberEntryPopUp} className={styles.actionButton}>
                            <img className={styles.mobIcon} src={MobileIcon} alt="MobileIcon"/>
                            <p>LOGIN WITH PHONE NUMBER</p>
                        </div>
                    </div> */}
                    {/* <div className={styles.termContainer}>
                        <p>By creating Fleek account, you are agreeing to our</p>
                        <div className={styles.termsButton}>Terms & Conditions</div>
                    </div> */}
                </div>
                {showPopUps.mobileNoEntry && <NumberEntryPopUp GetOtp = {GetOtp} toggle={toggelNumberEntryPopUp}/>}
            </div>    
        </div>
    )
}